import React from 'react';

const PMCard = ({ children, className = '', ...props }) => {
  return (
    <div 
      className={`pm-card bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-600 rounded-lg p-4 mb-4 shadow-sm ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

export default PMCard; 